import { render, staticRenderFns } from "./ProductSearchDropdown.vue?vue&type=template&id=a2291122"
import script from "./ProductSearchDropdown.vue?vue&type=script&lang=js"
export * from "./ProductSearchDropdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports